import { Module } from 'vuex'
import config from '@/config'

// store
import { RootState } from '../../../store/state_models'

// services
import { LcPhoneService } from '../../../services/LCPhoneService'

export interface RegulatoryBundleStoreModule {
  loading: boolean
  regulatoryBundles: any[]
  bundleDetails: any
}


export const regulatoryBundle: Module<RegulatoryBundleStoreModule, RootState> = {
  namespaced: true,
  state: {
    loading: false,
    regulatoryBundles: [],
    bundleDetails: {},
    tableSpinner: false,
  } as RegulatoryBundleStoreModule,
  getters: {
    /* companyHasWallet: state => {
       return state.companyHasWallet
     }, */
  },
  mutations: {
    regulatoryBundles(state, payload) {
      state.regulatoryBundles = []
      state.regulatoryBundles = payload
    },
    tableSpinner(state, payload) {
      state.tableSpinner = payload
    },
  },
  actions: {
    reset({ commit }) {
      commit('loading', false)
      commit('regulatoryBundles', [])
      commit('bundleDetails', {})
      commit('tableSpinner', false)
    },
    async listAllBundles({ commit, rootState }) {
      try {
        commit('tableSpinner', true)
        const locationId = rootState?.locations.currentLocation.id as string
        const res = await LcPhoneService.listRegulatoryBundles(locationId)
        commit('regulatoryBundles', res)
        commit('tableSpinner', false)
        return res
      } catch (error) {
        commit('tableSpinner', false)
        throw error
      }
    },
    async submitAddressInformation({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.submitAddressInformation(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async createRegulatoryBundle({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.createRegulatoryBundle(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async createEndUser({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.createEndUser(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async listAddresses({ commit, rootState }) {
      try {
        const locationId = rootState?.locations.currentLocation.id as string
        const res = await LcPhoneService.listAddresses(locationId)
        return res
      } catch (error) {
        throw error
      }
    },
    async submitRegulatoryBundle({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.submitRegulatoryBundle(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async attachDocuments({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.attachDocuments(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async deleteBundle({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.deleteBundle(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async deleteAddress({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.deleteAddress(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async getBundleDetails({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.getBundleDetails(data)
        return res
      } catch (error) {
        throw error
      }
    },
    async getRejectionReason({ commit, rootState }, data: any) {
      try {
        const res = await LcPhoneService.getRejectionReason(data)
        return res
      } catch (error) {
        throw error
      }
    },
  },
}
